import { useRef, useState } from 'react';
import './CommercialIndustries.css';
import commercialBg from '../../assets/commercial_banner_bg.png';
import imgWarehouses   from '../../assets/com_sector_warehouses.png';
import imgManufacturing from '../../assets/com_sector_manufacturing.png';
import imgCommercialBuildings from '../../assets/com_sector_commercial_buildings.png';
import imgAgriculture  from '../../assets/com_sector_agriculture.png';
import imgColdStorage  from '../../assets/com_sector_cold_storage.png';
import imgAutomotive   from '../../assets/com_sector_automotive.png';
import imgRetail       from '../../assets/com_sector_retail.png';
import imgHospitality  from '../../assets/com_sector_hospitality.jpg';

const industries = [
  {
    title: 'Warehouses',
    desc: 'Reduce costs and power operations around the clock.',
    img: imgWarehouses,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M1 21V9l11-6 11 6v12" stroke="#eaff50" strokeWidth="1.6" strokeLinejoin="round" />
        <rect x="8" y="13" width="8" height="8" stroke="#eaff50" strokeWidth="1.6" />
        <line x1="12" y1="13" x2="12" y2="21" stroke="#eaff50" strokeWidth="1.6" />
      </svg>
    ),
  },
  {
    title: 'Manufacturing',
    desc: 'Ensure reliability and optimise energy usage.',
    img: imgManufacturing,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="14" width="4" height="7" stroke="#eaff50" strokeWidth="1.6" />
        <rect x="9" y="10" width="4" height="11" stroke="#eaff50" strokeWidth="1.6" />
        <rect x="16" y="6" width="4" height="15" stroke="#eaff50" strokeWidth="1.6" />
        <line x1="2" y1="21" x2="20" y2="21" stroke="#eaff50" strokeWidth="1.6" />
      </svg>
    ),
  },
  {
    title: 'Commercial Buildings',
    desc: 'Lower bills and improve efficiency.',
    img: imgCommercialBuildings,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="2" width="18" height="20" rx="1" stroke="#eaff50" strokeWidth="1.6" />
        <line x1="3" y1="8" x2="21" y2="8" stroke="#eaff50" strokeWidth="1.6" />
        <line x1="3" y1="14" x2="21" y2="14" stroke="#eaff50" strokeWidth="1.6" />
        <line x1="9" y1="2" x2="9" y2="22" stroke="#eaff50" strokeWidth="1.6" />
        <line x1="15" y1="2" x2="15" y2="22" stroke="#eaff50" strokeWidth="1.6" />
      </svg>
    ),
  },
  {
    title: 'Agriculture & Farms',
    desc: 'Reliable power for every season and operation.',
    img: imgAgriculture,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <circle cx="7" cy="17" r="3" stroke="#eaff50" strokeWidth="1.6" />
        <circle cx="17" cy="18" r="2" stroke="#eaff50" strokeWidth="1.6" />
        <path d="M10 17h4l1-5H8l-1 3" stroke="#eaff50" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M13 12V8l4 2" stroke="#eaff50" strokeWidth="1.6" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Cold Storage Facilities',
    desc: 'Maintain consistent cooling and protect stock.',
    img: imgColdStorage,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <line x1="12" y1="2" x2="12" y2="22" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="2" y1="12" x2="22" y2="12" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="19.07" y1="4.93" x2="4.93" y2="19.07" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="12" cy="12" r="3" stroke="#eaff50" strokeWidth="1.6" />
      </svg>
    ),
  },
  {
    title: 'Automotive Workshops',
    desc: 'Power your tools and keep business moving.',
    img: imgAutomotive,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="10" width="20" height="8" rx="2" stroke="#eaff50" strokeWidth="1.6" />
        <path d="M5 10l2-4h10l2 4" stroke="#eaff50" strokeWidth="1.6" strokeLinejoin="round" />
        <circle cx="7" cy="18" r="2" stroke="#eaff50" strokeWidth="1.6" />
        <circle cx="17" cy="18" r="2" stroke="#eaff50" strokeWidth="1.6" />
      </svg>
    ),
  },
  {
    title: 'Hospitality Venues',
    desc: 'Uninterrupted power for exceptional guest experiences.',
    img: imgHospitality,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M3 16c0-4.97 4.03-9 9-9s9 4.03 9 9" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="2" y1="16" x2="22" y2="16" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="12" y1="7" x2="12" y2="4" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="12" y1="20" x2="12" y2="22" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: 'Retail Centres',
    desc: 'Keep your stores running with reliable energy.',
    img: imgRetail,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" stroke="#eaff50" strokeWidth="1.6" strokeLinejoin="round" />
        <line x1="3" y1="6" x2="21" y2="6" stroke="#eaff50" strokeWidth="1.6" />
        <path d="M16 10a4 4 0 0 1-8 0" stroke="#eaff50" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
];

const CARD_WIDTH = 216; // 200px card + 16px gap

export default function CommercialIndustries() {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const index = Math.round(scrollRef.current.scrollLeft / CARD_WIDTH);
    setActiveIndex(Math.min(index, industries.length - 1));
  };

  const scrollTo = (i) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollTo({ left: i * CARD_WIDTH, behavior: 'smooth' });
  };

  return (
    <section className="cind-section">
      <div className="cind-inner">

        {/* Centered header */}
        <div className="cind-header">
          <p className="cind-tag">
            <span className="cind-tag-line" />
            INDUSTRIES WE WORK WITH
            <span className="cind-tag-line" />
          </p>
          <h2 className="cind-title">Solutions for Every Sector</h2>
        </div>

        {/* Horizontally scrollable card row */}
        <div className="cind-scroll-wrap" ref={scrollRef} onScroll={handleScroll}>
          <div className="cind-track">
            {industries.map((ind, i) => (
              <div key={i} className="cind-card">
                <div className="cind-card-img-wrap">
                  <img src={ind.img} alt={ind.title} className="cind-card-img" style={{ objectPosition: `${(i * 12) % 100}% center` }} />
                </div>
                <div className="cind-card-body">
                  <div className="cind-card-icon">{ind.icon}</div>
                  <h3 className="cind-card-title">{ind.title}</h3>
                  <p className="cind-card-desc">{ind.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots */}
        <div className="cind-dots">
          {industries.map((_, i) => (
            <button
              key={i}
              className={`cind-dot${activeIndex === i ? ' cind-dot--active' : ''}`}
              onClick={() => scrollTo(i)}
              aria-label={`Go to ${industries[i].title}`}
            />
          ))}
        </div>

        {/* Bottom CTA bar */}
        <div className="cind-cta">
          <div className="cind-cta-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M13 2L4.09 12.11A1 1 0 0 0 5 14h6l-1 8 8.91-10.11A1 1 0 0 0 18 10h-6l1-8z" fill="#eaff50" />
            </svg>
          </div>
          <div className="cind-cta-text">
            <span className="cind-cta-line1">Different industries. Same goal.</span>
            <span className="cind-cta-line2">Smarter energy. Stronger business.</span>
          </div>
        </div>

      </div>
    </section>
  );
}
